const DEFAULT_MIME_BY_EXTENSION = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const toSafeUpperSnake = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toUpperCase()
  .replace(/[^A-Z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const buildFileTimestampSegment = (date = new Date()) => {
  const pad = (value) => String(value).padStart(2, '0');

  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
};

export const buildAccountStatementFileName = (customerName, extension) => {
  const normalizedName = toSafeUpperSnake(customerName) || 'CLIENTE';
  const normalizedExtension = String(extension || '').toLowerCase();

  return `estado_de_cuenta_${normalizedName}_${buildFileTimestampSegment()}.${normalizedExtension}`;
};

export const downloadBlobFile = (response, fileName, mimeType) => {
  const fallbackType = mimeType || DEFAULT_MIME_BY_EXTENSION[String(fileName || '').split('.').pop().toLowerCase()] || 'application/octet-stream';
  const blob = (typeof Blob !== 'undefined' && response instanceof Blob)
    ? response
    : new Blob([response], { type: fallbackType });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
